import { render, staticRenderFns } from "./FilterTab.vue?vue&type=template&id=2370a2f6&"
import script from "./FilterTab.vue?vue&type=script&lang=ts&"
export * from "./FilterTab.vue?vue&type=script&lang=ts&"
import style0 from "./FilterTab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports